import {getYouTubeId} from "@utils/get-youtube-id";

export const getYouTubeThumbnail = (url?: string): string | null => {
    const id = getYouTubeId(url);
    return id ? `https://img.youtube.com/vi/${id}/mqdefault.jpg` : null;
};
